<template>
  <b-overlay :show="pending" rounded="sm">
    <div class="overflow-div">
      <div class="boxclose" @click="close"></div>
      <h3 class="my-4 form-header">
        <i class="fas fa-bell fa-1x"></i>{{ $t("notification_title") }}
      </h3>
      <div class="d-flex">
        <div class="flex-1 notification_action_left">
          <i
            v-if="notificationList.length > 0"
            class="fas fa-check-double mr-2 notification_button check-button-notification"
            @click="checkNotification(notificationList, 'all')"
          ></i>
        </div>
        <div class="flex-1 notification_action_right">
          <i
            v-if="selectedNotifications.length > 0"
            class="fas fa-eye mr-2 notification_button"
            @click="seeNotification(notificationList, 'all')"
          ></i>
          <i
            v-if="selectedNotifications.length > 0"
            class="fas fa-trash-alt mr-3 notification_button"
            @click="deleteNotifications"
          ></i>
        </div>
      </div>
      <b-list-group class="mt-1" v-if="!isNonNotificationRendered">
        <transition-group
          name="custom-classes-transition"
          tag="div"
          leave-active-class="animated bounceOutRight"
        >
          <b-list-group-item
            v-for="i in notificationList"
            :key="i.id"
            class="notification-list-item"
            @click="seeNotification(i, 'single')"
          >
            <div class="d-flex w-200 justify-content-between">
              <span
                :class="[
                  'dot-item mr-4',
                  i.colorIndex === 0
                    ? 'f-point-ntf'
                    : i.colorIndex === 1
                    ? 's-point-ntf'
                    : i.colorIndex === 2
                    ? 't-point-ntf'
                    : 'p-point-ntf'
                ]"
                @click.stop="checkNotification(i, 'notAll')"
                v-if="i.frontendDeleteChecked !== true"
              ></span>
              <span
                :class="['dot-item mr-4 text-center']"
                v-else
                @click.stop="checkNotification(i, 'notAll')"
                ><i class="fas fa-check-circle notification_check"></i>
              </span>
              <h5
                :class="[
                  'mb-1 flex-fill',
                  i.colorIndex === -1 ? 'p-ntf-item' : 'a-ntf-item'
                ]"
                v-if="i.title"
              >
                {{ i.title.toUpperCase() }}
              </h5>
              <small :class="i.colorIndex !== -1 ? 'item-date' : 'p-ntf-date'">
                {{ formatDate(i.updatedAt) }}
              </small>
            </div>

            <p
              :class="
                i.colorIndex !== -1 ? 'mb-1 item-body' : 'mb-1 p-ntf-text'
              "
            >
              <span v-if="textId === null || textId != i.id">
                {{ ntfTextShorting(i.text) }}
              </span>
              <span v-else> {{ i.text }} </span>
            </p>
          </b-list-group-item>
        </transition-group>
      </b-list-group>
      <div class="non-notification" v-else>
        <span class="pt-4"> <i class="fas fa-bell-slash fa-5x "> </i></span>
        <span class="pl-4 pt-3 pb-4"> {{ $t("no_notification_text") }} </span>
      </div>
      <div class="ntf-buttons">
        <infinite-loading
          ref="infiniteLoading"
          v-if="maxSize === 'lg' && notificationList.length"
          :identifier="infiniteId"
          spinner="spiral"
          @infinite="infiniteScroll"
        >
          <div slot="spinner"></div>
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
        <button
          v-if="maxSize !== 'lg' && notificationList.length > 0"
          class="view-all btn btn-secondary w-100"
          @click="viewAll"
        >
          {{ $t("notification_view_button") }}
        </button>
      </div>
    </div>
  </b-overlay>
</template>
<script>
import InfiniteLoading from "vue-infinite-loading";
export default {
  components: {
    InfiniteLoading
  },
  data: () => ({
    notificationList: [],
    currentPage: 0,
    infiniteId: +new Date(),
    dotColors: ["#ff8c1c", "#44a5ab", "#512e83"],
    textId: null,
    maxSize: "",
    pending: false,
    checkAllValue: false,
    selectedNotifications: [],
    isNonNotificationRendered: false
  }),
  methods: {
    gameNotificationTotalUnseen() {
      this.$store.dispatch("gameNotificationTotalUnseen").then(response => {
        this.$store.commit("NOTIFICATION_TOTAL", response);
      });
    },
    checkNotification(item, value) {
      if (value === "notAll") {
        item.frontendDeleteChecked = !item.frontendDeleteChecked;
        if (this.selectedNotifications.includes(item.id) !== true) {
          this.selectedNotifications.push(item.id);
        } else {
          let elementIndex = this.selectedNotifications.indexOf(item.id);
          this.selectedNotifications.splice(elementIndex, 1);
        }
      } else if (value === "multiple") {
        item.forEach(element => {
          this.notificationList.forEach(ntfVal => {
            if (element === ntfVal.id) {
              ntfVal.frontendDeleteChecked = false;
              this.$forceUpdate();
            }
          });
        });
        this.selectedNotifications = [];
      } else {
        this.checkAllValue = !this.checkAllValue;
        if (this.checkAllValue === true) {
          this.notificationList.forEach(element => {
            element.frontendDeleteChecked = this.checkAllValue;
            if (this.selectedNotifications.includes(element.id) !== true) {
              this.selectedNotifications.push(element.id);
            }
          });
        } else {
          this.notificationList.forEach(
            element => (element.frontendDeleteChecked = this.checkAllValue)
          );
          this.selectedNotifications = [];
        }
      }
      this.$forceUpdate();
    },
    deleteNotifications() {
      let body = {
        notificationIdList: this.selectedNotifications,
        gameName: this.$store.getters.getGame.gameName
      };
      this.$store
        .dispatch("deleteNotifications", {
          ...body
        })
        .then(response => {
          if (response.success) {
            this.selectedNotifications.forEach(element => {
              const deletedItem = this.notificationList.find(value => {
                return element === value.id;
              });
              this.notificationList.splice(
                this.notificationList.indexOf(deletedItem),
                1
              );
            });

            this.getNotification(0);
            this.gameNotificationTotalUnseen();
            this.isNonNotificationRendered = false;
            this.selectedNotifications = [];
            if (this.maxSize === "lg") {
              this.currentPage = 0;
              this.$nextTick(() => {
                this.$refs.infiniteLoading.$emit("$InfiniteLoading:reset");
              });
              this.infiniteScroll();
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.pending = false;
        });
    },
    formatDate(timestamp) {
      const moment = require("moment");
      return moment(timestamp).format("lll");
    },
    getNotification(page) {
      this.pending = true;
      let currentpage = page;
      this.$store
        .dispatch("fetchNotifications", currentpage)
        .then(response => {
          this.notificationList = response.data;
          if (this.notificationList.length > 0)
            this.isNonNotificationRendered = false;
          else this.isNonNotificationRendered = true;
          this.notificationList.forEach(element => {
            element.frontendDeleteChecked = false;
          });
          this.pending = false;
          this.ntfIndexController(this.notificationList);
        })
        .catch(err => {
          console.log(err);
          this.pending = false;
        });
    },
    infiniteScroll($state) {
      setTimeout(() => {
        this.currentPage++;
        let currentpage = this.currentPage;
        this.$store
          .dispatch("fetchNotifications", currentpage)
          .then(response => {
            this.ntfIndexController(response.data);
            if (response.data.length > 0) {
              response.data.forEach(item => {
                this.notificationList.push(item);
              });
              $state.loaded();
            } else {
              $state.complete();
            }
          });
      }, 100);
    },
    ntfTextShorting(value) {
      // Notification text shortening function
      let newNotification = [];
      for (let i = 0; i < value.length; i++) {
        if (i <= 100) {
          newNotification.push(value[i]);
        }
      }
      let returnNTF = newNotification.join("");
      if (returnNTF.length >= 100) {
        returnNTF = returnNTF + "...";
      }
      return returnNTF;
    },
    close() {
      this.$emit("close");
    },
    viewAll() {
      this.maxSize = "lg";
      this.$emit("maxSize", this.maxSize);
      let element = document.querySelectorAll(".overflow-div");
      element[0].style.maxHeight = "100vh";
    },
    seeNotification(item, type) {
      //Seen - Unseen //
      this.textId === item.id ? (this.textId = null) : (this.textId = item.id);
      //
      let body = {
        gameName: this.$store.getters.getGame.gameName,
        notificationIdList: []
      };
      if (type === "single") {
        // notification single click

        body.notificationIdList.push(item.id);
        if (this.textId === item.id) {
          // Notification Detail Show
          if (item.seen !== true) {
            this.$store
              .dispatch("seeNotification", { ...body })
              .then(response => {
                if (response.success === true) {
                  item.seen = true;
                }
              });
          }
        } else {
          //Notification Detail Unshow
          this.checkNotification(item, "notAll");
          this.closeNotification("single");
        }
      } else {
        //Notification All request
        if (this.selectedNotifications.length > 0) {
          this.notificationList.forEach(element => {
            this.selectedNotifications.forEach(selectedElement => {
              if (element.id === selectedElement && !element.seen) {
                body.notificationIdList.push(selectedElement);
                element.seen = true;
              }
            });
          });
          /*See All Notification */
          if (body.notificationIdList.length > 0)
            this.$store
              .dispatch("seeNotification", { ...body })
              .then(response => {
                if (response.success) {
                  this.checkNotification(
                    this.selectedNotifications,
                    "multiple"
                  );
                  this.closeNotification("all");
                }
              });
        }
      }
    },
    ntfIndexController(value) {
      // Notification color change method
      value.forEach((element, index) => {
        if (element.seen === true) {
          (element.colorIndex = -1), (element.backgroundColor = "#F0F0F0");
        } else {
          if (index < 3) element.colorIndex = index;
          else {
            let indexValue = index % 3;
            element.colorIndex = indexValue;
          }
        }
      });
      this.$forceUpdate();
    },
    closeNotification(type) {
      if (type) {
        this.gameNotificationTotalUnseen();
        this.ntfIndexController(this.notificationList);
      }
    }
  },
  mounted() {
    this.getNotification(this.currentPage);
  },

  watch: {
    textId: function(newVal, oldVal) {
      if (oldVal !== null && newVal !== null) {
        this.closeNotification("single");
      }
    }
  }
};
</script>
<style scoped>
.notification-title {
  font-size: 20px;
  text-align: center;
}
.item-date {
  color: #44a5ab;
  font-size: 1rem;
}
.item-body {
  color: grey;
  padding-top: 4px;
  padding-left: 50px;
}
.dot-item {
  border: 4px solid #fff;
  box-shadow: 1px 2px 1px 1px grey;
  border-radius: 20px;
  width: 30px;
  height: 30px;
}
.list-group {
  min-height: 570px !important;
}
.list-group-item {
  border: 1px solid #f5f5f5 !important;
}
button.view-all.btn.btn-secondary.w-100 {
  /* position: relative;
  bottom: -15px;*/
  min-width: 450px !important;
}
.read-more {
  color: #512e83;
  font-size: 13px;
  font-weight: 600;
}
.read-more:hover {
  color: #ff8c1c;
  cursor: pointer;
}
.overflow-div {
  overflow: auto;
  height: 730px;
}
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
::-webkit-scrollbar-track-piece {
  background-color: #f7e2cd;
}
::-webkit-scrollbar-thumb:vertical {
  height: 30px;
  background-color: #ff8c1c;
}
i.fas.fa-check-double.mr-2.notification_button:hover {
  cursor: pointer;
}
i.fas.fa-trash-alt.mr-3.notification_button:hover {
  cursor: pointer;
}
i.fas.fa-eye.mr-2.notification_button {
  cursor: pointer;
}
</style>
